<template>
  <div>
    <div class="d-flex justify-end">
      <div class="d-flex">
        <botao-padrao v-if="
          form.participanteClienteNome &&
          existeOrcamentoItemDetalhe &&
          form.participanteClienteId
        " class="mt-3 mb-3 mr-2" @click="abrirModalVisualizarUltimosPrecosOrcados">
          {{
            $t(
              'modulos.orcamentos.formulario.itensOrcamento.botoes.visualizar_ultimos_precos_orcados'
            )
          }}
        </botao-padrao>
        <botao-padrao v-if="!visualizacao" class="mt-3 mb-3"
          :disabled="!form.participanteClienteNome || !!form.ordemServicoCodigo"
          :tooltip="tooltipAbrirModalInstrumentos" @click="adicionaItemOrcamento">
          {{
            $t(
              'modulos.orcamentos.formulario.itensOrcamento.botoes.novoItemOrcamento'
            )
          }}
        </botao-padrao>
      </div>
    </div>
    <v-data-table v-if="form.orcamentoItem.length" :key="keyAtualiza" :headers="tabela.colunas"
      :items="form.orcamentoItem" :single-expand="singleExpand" :expanded.sync="expanded" item-key="numeroItem"
      :items-per-page="Number(-1)" show-expand dense hide-default-footer>
      <!-- eslint-disable vue/valid-v-slot-->
      <template v-slot:item.numero="{ item, index }">
        <div class="d-flex" style="align-items: center">
          <div>
            <dropdown-padrao v-if="!visualizacao && !form.ordemServicoCodigo" text color="secondary"
              style="width: 100% !important">
              <template #botao>
                <v-icon> $dotsVertical </v-icon>
              </template>

              <v-list-item-group style="overflow-y: auto">
                <v-list-item class="d-flex min-height-drop-item" @click="duplicar(item)">
                  {{ $t('geral.botoes.duplicar') }}
                </v-list-item>
                <v-divider />
                <v-list-item class="d-flex min-height-drop-item" @click="excluir(index)">
                  <v-icon>$mdiTrashCanOutline</v-icon>
                  {{ $t('geral.botoes.excluir') }}
                </v-list-item>
              </v-list-item-group>
            </dropdown-padrao>
          </div>
          <icone-padrao v-if="item.orcamentoItemInstrumento && !form.ordemServicoCodigo"
            :icone="definirIconeAdicionadoRemovido(item).icon"
            :classe-icone="definirIconeAdicionadoRemovido(item).color" size="20"
            :tooltip="definirIconeAdicionadoRemovido(item).tooltip" />
          <!-- icone aprovação -->

          <icone-padrao v-if="deveMostrarIconeAguardandoAprovacaoItem(item) && visualizacao"
            :icone="'$fileClockOutline'" :tooltip="'Aguardando Aprovação'" classe-icone="ml-2" cor="purple" />
          <icone-padrao v-else-if="
            !existeItemReprovado(item) &&
            deveMostrarIconeItemOrcamento() &&
            visualizacao
          " :icone="'$fileCheckOutline'" :tooltip="'Aprovado'" classe-icone="ml-2 primary-success-700--text" />
          <icone-padrao v-else-if="
            item.quantidadeAprovada == 0 &&
            visualizacao &&
            deveMostrarIconeItemOrcamento()
          " :icone="'$fileDocumentRemoveOutline'" :tooltip="'Reprovado'" classe-icone="ml-2 danger--text" />

          <icone-padrao v-else-if="
            existeItemReprovado(item) &&
            visualizacao &&
            deveMostrarIconeItemOrcamento()
          " :icone="'$mdiFileCheck'" :tooltip="'Aprovado Parcialmente'" classe-icone="ml-2" />
          <div class="ml-2">
            {{ item.numeroItem }}
          </div>
        </div>
      </template>
      <template v-slot:item.instrumento="{ item, index }">
        <div class="d-flex">
          <div v-if="!visualizacao && !form.ordemServicoCodigo" style="align-self: center" class="mr-2 d-flex w-40">
            <v-icon size="22" :disabled="!!item.orcamentoItemDetalhe.length" @click="abreModalInstrumentos(index)">
              $search
            </v-icon>
          </div>
          <div class="d-flex">
            <accordion-tabela v-if="item.instrumentosNomes?.length > 1">
              <template v-slot:header="{ on }">
                <div class="d-flex" style="width: 125px" v-on="item.instrumentosNomes[0] ? on : null">
                  <span>{{ item.instrumentosNomes?.length }} </span>
                  <span> {{ '-Instrumentos' }} </span>
                </div>
              </template>
              <div v-for="(nome, indexInstrumento) in item.instrumentosNomes" :key="nome" class="test">
                <v-chip :close="!visualizacao && !form.ordemServicoCodigo" label color="cinza200"
                  close-icon="$closeBoxOutline" style="border-style: none !important"
                  @click:close="removerInstrumento(index, indexInstrumento)">
                  <span>{{ nome }}</span>
                  <v-icon class="ml-2" size="18" @click="abreModalEditarInstrumento(item, nome, index, indexInstrumento)">
                    $edit
                  </v-icon>
                </v-chip>
              </div>
            </accordion-tabela>

            <div v-if="item.instrumentosNomes?.length == 1">
              <div v-for="(nome, indexInstrumento) in item.instrumentosNomes" :key="nome">
                <v-chip :close="!visualizacao && !form.ordemServicoCodigo" label outlined
                  style="border-style: none !important" color="cinza200" close-icon="$closeBoxOutline"
                  @click:close="removerInstrumento(index, indexInstrumento)">
                  <span>{{ nome }}</span>
                  <v-icon class="ml-2" size="18" @click="abreModalEditarInstrumento(item, nome, index, indexInstrumento)"
                    :disabled="visualizacao">
                    $edit
                  </v-icon>
                </v-chip>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:item.descricao="{ item }">
        <v-tooltip v-if="item.descricao" top class="pl-0">
          <template v-slot:activator="{ on }">
            <div v-on="on">
              <div v-if="!item.trocaSpanInputDescricao" class="col-12 cursor-pointer texto-descricao"
                @click="trocaSpanColocaFocoDescricao(item.numeroItem)">
                <span v-html="item.descricao" />
              </div>
            </div>
          </template>
          <span>{{ item.descricao }}</span>
        </v-tooltip>
        <div v-if="!item.descricao">
          <div class="descricao-obrigatorio">
            <span class="descricao-obrigatorio-asterisco">*</span>
            <div v-if="!item.trocaSpanInputDescricao" class="col-12 cursor-pointer texto-descricao"
              @click="trocaSpanColocaFocoDescricao(item.numeroItem)">
              <span v-html="item.descricao" />
            </div>
          </div>
          <span>{{ item.descricao }}</span>
        </div>
        <input-textarea v-if="item.trocaSpanInputDescricao && !visualizacao" :ref="'inputDescricao' + item.numeroItem"
          v-model="item.descricao" style="width: 100%; min-width: 240px" class="mb-2 ml-2 texto-descricao"
          @blur="atualizaSpanInputDescricao(item.numeroItem)" :disabled="visualizacao" />
      </template>
      <template v-slot:item.prazoEntrega="{ item }">
        <div class="col-12" style="text-align-last: center">
          <span>{{ item.prazoEntrega }}</span>
        </div>
      </template>
      <template v-slot:item.qtd="{ item }">
        <div v-if="!item.trocaSpanInputQuantidade && form.ordemServicoCodigo" class="col-12"
          style="text-align-last: center" @click="trocaSpanColocaFocoQuantidade(item.numeroItem)">
          <span>{{ item.quantidade }}</span>
        </div>
        <div v-else class="col-12" style="text-align-last: center"
          @click="trocaSpanColocaFocoQuantidade(item.numeroItem)">
          <InputNumber :ref="'inputQuantidade' + item.numeroItem" v-model="item.quantidade"
            input-style="border-radius: 8px; border-color: rgb(117 124 131); max-width: 80px;" class="p-inputtext-sm"
            :min="0" :disabled="form.ordemServicoCodigo || visualizacao"
            @blur="calcularLinhaPrincipal(item.numeroItem)" />
        </div>
      </template>
      <template v-slot:item.valorUnitario="{ item }">
        <div class="col-12" style="text-align-last: end; padding-right: 0"
          @click="trocaSpanColocaFocoValorUnitario(item.numeroItem)">
          <span>{{
            item.valorUnitario
              ? item.valorUnitario
              : '0,00' | formataValorPrecisaoDois
          }}</span>
        </div>
      </template>
      <template v-slot:item.desconto="{ item }">
        <div class="col-12 cursor-pointer" style="text-align-last: end; padding-right: 0"
          @click="trocaSpanColocaFocoDesconto(item.numeroItem)">
          <span>{{
            item.desconto ? item.desconto : '0,00' | formataValorPrecisaoDois
          }}</span>
        </div>
      </template>
      <template v-slot:item.valorTotal="{ item }">
        <div class="col-12" style="text-align-last: end; padding-right: 0">
          <span>{{
            item.valorTotal
              ? item.valorTotal
              : '0,00' | formataValorPrecisaoDois
          }}</span>
        </div>
      </template>
      <template v-slot:item.selecionar="{ item }">
        <v-checkbox v-model="item.flagItemCortesia" @change="selecionarItemCortesia(item)" :disabled="visualizacao" />
      </template>
      <template v-slot:item.orcamentoConsulta="{ item }">
        <div class="d-flex items-center">
          <InputOrcamentosConsulta v-model="item.orcamentoItemInstrumento[0].orcamentoConsulta" sem-label
            class="flex-fill input-tabela-campos-adicionais my-1" :estilo-customizado="`font-size: 14px; ${item.orcamentoItemInstrumento[0].orcamentoConsulta
              ? 'width: 170px'
              : ''
              };`" :multiplos="false" :orcamentos-consulta="orcamentosConsulta" :disabled="visualizacao" />
          <botao-padrao v-if="item.orcamentoItemInstrumento[0].orcamentoConsulta" class="mt-1 px-0 mr-1"
            tooltip="Limpar" outlined @click="limparOrcamentoConsulta(item)">
            <v-icon> $closeBoxOutline </v-icon>
          </botao-padrao>
          <botao-padrao v-if="item.orcamentoItemInstrumento[0].orcamentoConsulta" class="mt-1 px-0"
            tooltip="Visualizar Orçamentos Consulta" outlined @click="
              abrirOrcamentoAba(
                item.orcamentoItemInstrumento[0].orcamentoConsulta
              )
              ">
            <v-icon> $eye </v-icon>
          </botao-padrao>
        </div>
      </template>
      <template v-slot:item.flagFinalizarOrcamentoConsulta="{ item }">
        <input-select v-model="item.orcamentoItemInstrumento[0].flagFinalizarOrcamentoConsulta
          " :disabled="!item.orcamentoItemInstrumento[0].orcamentoConsulta?.value ||
            visualizacao
            " :options="opcoes.boleanoEnum" estilo-customizado="font-size: 14px;"
          class="flex-fill input-tabela-campos-adicionais my-1" :placeholder="$t('geral.inputs.selecione')" sem-label />
      </template>

      <template v-slot:item.verificarTotal="{ item }">
        <icone-padrao
          :icone="verificarItemTotal(item) ? 'pi-exclamation-triangle' : 'pi-check'"
          size="20"
          :cor="verificarItemTotal(item) ? 'warning' : 'green'"
          :tooltip="getTooltipMessage(item)"
        />
      </template>

      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <v-simple-table dense class="subtable-itens-orcamento">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="th-simple-table" scope="col">
                    {{ $t('modulos.orcamentos.formulario.codigo') }}
                  </th>
                  <th class="th-simple-table" scope="col">
                    {{ $t('modulos.orcamentos.formulario.descricao') }}
                  </th>
                  <th class="th-simple-table" scope="col">
                    {{ $t('modulos.orcamentos.formulario.tipoCalibracao') }}
                  </th>
                  <th class="th-simple-table" scope="col" style="text-align: center">
                    {{ $t('modulos.orcamentos.formulario.prazo') }}
                  </th>
                  <th class="th-simple-table" scope="col" style="text-align: center">
                    {{ $t('modulos.orcamentos.formulario.quantidade') }}
                  </th>
                  <th class="th-simple-table" scope="col" style="text-align: center; min-width: 145px">
                    {{ $t('modulos.orcamentos.formulario.valor_unitario') }}
                  </th>

                  <th class="th-simple-table" scope="col" style="text-align: center; min-width: 130px">
                    {{
                      form.tipoDesconto == 'Percentual'
                        ? $t(
                          'modulos.orcamentos.formulario.desconto_icone_percent'
                        )
                        : $t('modulos.orcamentos.formulario.desconto')
                    }}
                  </th>
                  <th class="th-simple-table" scope="col" style="text-align: center">
                    {{ $t('modulos.orcamentos.formulario.valor_total') }}
                  </th>
                  <th class="th-simple-table" scope="col" style="text-align: center">
                    {{ $t('modulos.orcamentos.formulario.item_cortesia') }}
                  </th>
                  <th v-if="form.id && form.ordemServico" class="th-simple-table" scope="col">
                    {{ $t('modulos.orcamentos.formulario.aprovacao') }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(
                    instrumento, indexInstrumento
                  ) in item.orcamentoItemDetalhe" :key="instrumento.numeroItem" class="description-tr">
                  <td class="col-2">
                    <div class="d-flex">
                      <icone-padrao v-if="!form.ordemServicoCodigo" :icone="instrumento.flagRemovidoCliente
                        ? '$closeCircleOutline'
                        : '$successCircleOutline'
                        " :classe-icone="`${instrumento.flagRemovidoCliente
                          ? 'danger--text'
                          : 'primary-success-700--text'
                          } mt-2`" size="20" :tooltip="instrumento.flagRemovidoCliente
                            ? $t('modulos.contrato.item_removido')
                            : $t('modulos.contrato.item_validado')
                            " />
                      <!-- analise critica -->
                      <span class="mt-2 mr-2">
                        <icone-padrao v-if="
                          liberar &&
                          deveMostrarTooltipAnaliseCritica(instrumento)
                        " :icone="$vuetify.icons.values.alertWarningtOutline" cor="danger" tooltip="-">
                          <template #default>
                            <div v-for="(
                                tooltip, index
                              ) in montarTooltipAnaliseCritica(instrumento)" :key="index">
                              {{ tooltip }}
                            </div>
                          </template>
                        </icone-padrao>
                      </span>
                      <dropdown-padrao v-if="!visualizacao && !form.ordemServicoCodigo" :drop-w100="false" text
                        color="secondary">
                        <template #botao>
                          <v-icon> $dotsVertical </v-icon>
                        </template>
                        <v-list-item-group style="overflow-y: auto">
                          <v-list-item class="d-flex min-height-drop-item" @click="
                            removerTipoServicosEPecas(
                              item.numeroItem,
                              indexInstrumento,
                              item
                            )
                            ">
                            {{ $t('geral.botoes.remover') }}
                          </v-list-item>
                        </v-list-item-group>
                      </dropdown-padrao>
                      <span class="mt-2">
                        <!-- icone aprovação -->
                        <icone-padrao v-if="
                          instrumento.quantidade !=
                          instrumento.quantidadeAprovada &&
                          visualizacao &&
                          deveMostrarIconeAguardandoAprovacao(instrumento)
                        " :icone="'$fileClockOutline'" :tooltip="'Aguardando Aprovação'" cor="purple" />
                        <icone-padrao v-else-if="
                          instrumento.quantidade ==
                          instrumento.quantidadeAprovada &&
                          visualizacao &&
                          deveMostrarIconeAprovacao(instrumento)
                        " :icone="'$fileCheckOutline'" :tooltip="'Aprovado'"
                          classe-icone="primary-success-700--text" />
                        <icone-padrao v-else-if="
                          instrumento.quantidade !==
                          instrumento.quantidadeAprovada &&
                          visualizacao &&
                          deveMostrarIconeAprovacao(instrumento)
                        " :icone="'$fileDocumentRemoveOutline'" :tooltip="'Reprovado'" classe-icone="danger--text" />
                        <icone-padrao v-if="instrumento.itemId || instrumento.item" :icone="'$cogOutline'"
                          :tooltip="'Peça'" />
                        <icone-padrao v-if="instrumento.tipoServico == 'Calibracao'" :icone="'$wrenchClock'"
                          :tooltip="'Serviço de Calibração'" />
                        <icone-padrao v-if="instrumento.tipoServico == 'Manutencao'" :icone="'$wrenchCog'"
                          :tooltip="'Serviço de Manutenção'" />

                        {{ instrumento.codigo }}
                      </span>
                    </div>
                  </td>
                  <td class="col-3">
                    {{ instrumento.descricao }}
                  </td>
                  <td class="col-3">
                    {{
                      instrumento?.servico?.tipoCalibracao?.nome ||
                      instrumento?.tipoCalibracao
                    }}
                  </td>
                  <td class="col-1">
                    <InputNumber :ref="'inputPrazoServico' + instrumento.servicoId"
                      v-model="instrumento.prazoEntrega"
                      input-style="border-radius: 8px; border-color: rgb(117 124 131); max-width: 80px;"
                      class="p-inputtext-sm" :min="0" :disabled="visualizacao" @blur="
                        calcularLinhasItens(
                          item.numeroItem,
                          indexInstrumento,
                          item
                        )
                        " @focus="selecionarConteudo" />
                  </td>
                  <td class="col-1">
                    <InputNumber :ref="'inputQuantidadeServico' + instrumento.servicoId"
                      v-model="instrumento.quantidade"
                      input-style="border-radius: 8px; border-color: rgb(117 124 131); max-width: 80px;"
                      class="p-inputtext-sm" :min="0" :disabled="form.ordemServicoCodigo || visualizacao" @blur="
                        calcularLinhasItens(
                          item.numeroItem,
                          indexInstrumento,
                          item
                        )
                        " @focus="selecionarConteudo" />
                  </td>
                  <td class="col-1">
                    <InputNumber :ref="'inputValorUnitarioServico' + instrumento.servicoId"
                      v-model="instrumento.valorUnitario"
                      input-style="border-radius: 8px; border-color: rgb(117 124 131); max-width: 100px;" locale="pt-BR"
                      mode="decimal" :min-fraction-digits="2" :max-fraction-digits="2" class="p-inputtext-sm" :min="0"
                      :disabled="visualizacao || instrumento.flagItemCortesia" @blur="
                        calcularLinhasItens(
                          item.numeroItem,
                          indexInstrumento,
                          item
                        )
                        " @focus="selecionarConteudo" />
                  </td>

                  <td class="col-1">
                    <InputNumber :ref="'inputDescontoServico' + instrumento.servicoId" v-model="instrumento.desconto"
                      input-style="border-radius: 8px; border-color: rgb(117 124 131); max-width: 80px;" locale="pt-BR"
                      :min-fraction-digits="2" class="p-inputtext-sm"
                      :max-fraction-digits="2"
                      :disabled="visualizacao || instrumento.flagItemCortesia" :min="0" @blur="
                        calcularLinhasItens(
                          item.numeroItem,
                          indexInstrumento,
                          item
                        )
                        " @focus="selecionarConteudo" />
                  </td>
                  <td class="col-1">
                    <div style="text-align-last: end" class="col-12">
                      <span>{{
                        instrumento.valorTotal
                          ? instrumento.valorTotal
                          : '0,00' | formataValorPrecisaoDois
                      }}</span>
                    </div>
                  </td>
                  <td>
                    <v-checkbox v-model="instrumento.flagItemCortesia"
                      @change="selecionarDetalheItemCortesia(item, instrumento)" :disabled="visualizacao" />
                  </td>
                  <td v-if="form.id && form.ordemServico" class="col-2">
                    <input-select v-model="instrumento.tipoAprovacao" :options="opcoes.tipoAprovacao" :disabled="!item.orcamentoItemInstrumento[0]?.orcamentoConsulta
                      ?.value || visualizacao
                      " estilo-customizado="font-size: 14px; width: 150px;"
                      class="flex-fill input-tabela-campos-adicionais my-1 dkijkwnmp3"
                      :placeholder="$t('geral.inputs.selecione')" sem-label />
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <div v-if="!visualizacao && !form.ordemServicoCodigo" class="row">
            <div class="d-flex mt-1 mb-1 col-7">
              <dropdown-padrao text color="secondary" :drop-w100="false">
                <template #botao>
                  <div @click="abreModalTipoServicosCalibracao(item)">
                    <v-icon> $plus </v-icon>
                    {{ $t('geral.botoes.servicos_calibracao') }}
                  </div>
                </template>
              </dropdown-padrao>
              <dropdown-padrao text color="secondary" :drop-w100="false">
                <template #botao>
                  <div @click="abreModalTipoServicosManutencao(item)">
                    <v-icon> $plus </v-icon>
                    {{ $t('geral.botoes.servicos_manutencao') }}
                  </div>
                </template>
              </dropdown-padrao>
              <dropdown-padrao text color="secondary" :drop-w100="false">
                <template #botao>
                  <div @click="abreModalPecas(item)">
                    <v-icon> $plus </v-icon>
                    {{ $t('geral.botoes.pecas') }}
                  </div>
                </template>
              </dropdown-padrao>
            </div>
            <div class="d-flex mt-1 mb-1 col-5" style="padding-left: 100px" />
          </div>
        </td>
      </template>
    </v-data-table>
    <PesquisaTipoServicoManutencaoModal :show-modal="showModalTipoServicoManutencao"
      :selected="tipoServicoManutencaoSelecionados" :single-select="false"
      :instrumentos-selecionados-ids="instrumentosSelecionadosIds"
      @close-modal="manipulaModalPesquisaTipoServicosManutencao('', 'close')" @close-modal-add="
        manipulaModalPesquisaTipoServicosManutencao($event, 'add')
        " />
    <PesquisaTipoServicoCalibracaoModal :show-modal="showModalTipoServicoCalibracao"
      :selected="tipoServicoCalibracaoSelecionados" :single-select="false"
      :instrumentos-selecionados-ids="instrumentosSelecionadosIds"
      @close-modal="manipulaModalPesquisaTipoServicosCalibracao('', 'close')" @close-modal-add="
        manipulaModalPesquisaTipoServicosCalibracao($event, 'add')
        " />
    <PesquisaPecasModal :show-modal="showModalPecas" :selected="pecasSelecionadas" :single-select="false"
      :instrumentos-selecionados-ids="instrumentosSelecionadosIds"
      @close-modal="manipulaModalPesquisaPecas('', 'close')"
      @close-modal-add="manipulaModalPesquisaPecas($event, 'add')" />
    <VisualizarUltimosPrecosModal ref="modal-visualizar-ultimos-precos" :form="form" />
    <InstrumentoPorTipoModal ref="instrumento-tipo-modal" :cliente-selecionado="getParticipanteCliente"
      @associarInstrumentos="manipulaModalPesquisaInstrumentos" />
    <servico-calibracao-modal ref="servico-calibracao-modal" :instrumentos-ids="instrumentosSelecionadosIds"
      :local-execucao-id="form.localExecucaoId" @remover-servicos="removerViaModal"
      @close-modal="manipulaModalPesquisaTipoServicosCalibracao('', 'close')" @close-modal-add="
        manipulaModalPesquisaTipoServicosCalibracao($event, 'add')
        " />
    <servico-manutencao-modal ref="servico-manutencao-modal" :instrumentos-ids="instrumentosSelecionadosIds"
      :local-execucao-id="form.localExecucaoId" @remover-servicos="removerViaModal"
      @close-modal="manipulaModalPesquisaTipoServicosManutencao('', 'close')" @close-modal-add="
        manipulaModalPesquisaTipoServicosManutencao($event, 'add')
        " />
    <pecas-modal ref="pecas-modal" :instrumentos-ids="instrumentosSelecionadosIds"
      :local-execucao-id="form.localExecucaoId" @remover-servicos="removerViaModal"
      @close-modal="manipulaModalPesquisaPecas('', 'close')"
      @close-modal-add="manipulaModalPesquisaPecas($event, 'add')" />
    <instrumento-edicao-modal
      ref="modal-edicao-instrumento"
      :instrumento-id="editarInstrumentoId"
      :atualiza="true"
      cliente-selecionado="form.participanteClienteNome"
      @atualiza-instrumento-analise-tecnica="atualizaInstrumento"
    />
    <!-- <orcamentos-consulta-modal
      ref="modal-orcamentos-consulta"
    /> -->
  </div>
</template>
<script>
import ContratoService from '@common/services/cadastros/ContratoService';
import PesquisaPecasModal from '@components/fragments/Modals/PesquisaPecasModal';
import PesquisaTipoServicoCalibracaoModal from '@components/fragments/Modals/PesquisaTipoServicoCalibracaoModal';
import PesquisaTipoServicoManutencaoModal from '@components/fragments/Modals/PesquisaTipoServicoManutencaoModal';
import InstrumentoEdicaoModal from '../../operacao/components/modais/InstrumentoEdicaoModal.vue';
import InstrumentoPorTipoModal from './modais/InstrumentoPorTipoModal.vue';
import PecasModal from './modais/PecasModal.vue';
import ServicoCalibracaoModal from './modais/ServicoCalibracaoModal.vue';
import ServicoManutencaoModal from './modais/ServicoManutencaoModal.vue';
import VisualizarUltimosPrecosModal from './modais/VisualizarUltimosPrecosModal';
import helpers from '@common/utils/helpers';
import InputOrcamentosConsulta from './input-modal-orcamento-consulta';

export default {
  components: {
    PesquisaTipoServicoManutencaoModal,
    PesquisaTipoServicoCalibracaoModal,
    PesquisaPecasModal,
    VisualizarUltimosPrecosModal,
    InstrumentoPorTipoModal,
    ServicoCalibracaoModal,
    ServicoManutencaoModal,
    PecasModal,
    InstrumentoEdicaoModal,
    InputOrcamentosConsulta,
  },
  props: {
    form: {},
    prazoEntregaPadrao: { type: Number, default: null },
    visualizacao: { type: Boolean, default: false },
    orcamentosConsulta: { type: Array, default: () => [] },
  },
  data() {
    return {
      precoServicoContrato: null,
      keyAtualiza: 1,
      optionsInputMoney: {
        locale: 'pt-BR',
        prefix: '',
        suffix: '',
        length: 11,
        precision: 2,
      },
      expanded: [],
      renumeracaoItens: 1,
      instrumentosSelecionadosIds: [],
      instrumentosSelecionados: [],
      tipoServicoManutencaoSelecionados: [],
      tipoServicoCalibracaoSelecionados: [],
      pecasSelecionadas: [],
      singleExpand: false,
      mostraInputs: false,
      showModalTipoServicoManutencao: false,
      showModalTipoServicoCalibracao: false,
      showModalPecas: false,
      adicionadoPrimeiraDescricaoManutencao: false,
      adicionadoPrimeiraDescricaoCalibracao: false,
      calibracaoCampoOuLaboratorio: '',
      primeiroItemCalibracao: {},
      nomeServicoManutencao: '',
      tabela: {
        selecionados: [],
        dados: [],
        colunas: [
          {
            value: 'numero',
            text: this.$t('modulos.orcamentos.formulario.numero'),
            width: 130,
          },
          {
            value: 'instrumento',
            text: this.$t('modulos.orcamentos.formulario.instrumento'),
            width: 160,
          },
          {
            value: 'descricao',
            text: this.$t('modulos.orcamentos.formulario.descricao') + ' * ',
            cellClass: 'pl-0',
          },
          {
            value: 'prazoEntrega',
            text: this.$t('modulos.orcamentos.formulario.prazo'),
            width: 90,
            align: 'center',
          },
          {
            value: 'qtd',
            text: this.$t('modulos.orcamentos.formulario.quantidade'),
            width: 140,
            align: 'center',
          },
          {
            value: 'valorUnitario',
            text: this.$t('modulos.orcamentos.formulario.valor_unitario'),
            width: 150,
            align: 'end',
          },
          {
            value: 'desconto',
            text: this.$t('modulos.orcamentos.formulario.desconto'),
            width: 140,
            align: 'end',
            sorteable: false,
          },
          {
            value: 'valorTotal',
            text: this.$t('modulos.orcamentos.formulario.valor_total'),
            width: 130,
            align: 'end',
          },
          {
            value: 'selecionar',
            text: this.$t('modulos.orcamentos.formulario.item_cortesia'),
            width: 50,
            align: 'end',
          },
          {
            value: 'verificarTotal',
            text: ' ',
            width: 50,
            align: 'end',
          },
        ].concat(
          this.form.id && this.form.ordemServico
            ? [
              {
                value: 'orcamentoConsulta',
                text: this.$t(
                  'modulos.orcamentos.formulario.orcamento_consulta'
                ),
                width: 250,
                align: 'center',
              },
              {
                value: 'flagFinalizarOrcamentoConsulta',
                text: this.$t(
                  'modulos.orcamentos.formulario.finalizar_orcamento_consulta'
                ),
                width: 250,
                align: 'center',
              },
            ]
            : []
        ),
        indexAtualInstrumento: null,
        numeroItemOrcamento: 1,
        numeroItemTipoServicoManutencaoSelecionados: null,
        numeroItemTipoServicoCalibracaoSelecionados: null,
        numeroItemPecasSelecionadas: null,
      },
      editarInstrumentoId: null,
      indexInstrumentoNome: 0,
      totalPontosExtras: 0,
      valorTotal: 0,
      opcoes: {
        boleanoEnum: helpers.BoleanoEnum,
        tipoAprovacao: helpers.TipoAprovacaoItemOrcamentoEnum,
      },
    };
  },
  computed: {
    liberar() {
      return !!this.$route.query?.liberar;
    },
    existeOrcamentoItemDetalhe: function () {
      let existeDetalhe = false;
      this.form.orcamentoItem.map((item) => {
        if (item.orcamentoItemDetalhe.length) existeDetalhe = true;
      });
      return existeDetalhe;
    },
    tamanhoOrcamentoItemDetalhe: function () {
      let tamanho = 0;
      this.form.orcamentoItem.map((item) => {
        tamanho += item.orcamentoItemDetalhe.length;
      });
      return tamanho;
    },
    tooltipAbrirModalInstrumentos: function () {
      if (this.form.participanteClienteId) return '';
      else return this.$t('geral.erros.participante_preencher');
    },
    situacoesPecas() {
      return [
        'AprovadoPecas',
        'AprovadoServicosPecas',
        'AprovadoAutomaticamente',
        'AprovadoParcialPecas',
        'AprovadoParcialServicosPecas',
        'ReprovadoServicosPecas',
        'ReprovadoPecas',
        'Faturado',
      ];
    },
    situacoesServicos() {
      return [
        'AprovadoServicos',
        'AprovadoServicosPecas',
        'AprovadoAutomaticamente',
        'AprovadoParcialServicos',
        'AprovadoParcialServicosPecas',
        'ReprovadoServicosPecas',
        'ReprovadoServicos',
        'Faturado',
      ];
    },
    getParticipanteCliente() {
      const valor = this.form.participanteClienteNome;

      if (this.form.participanteClienteNome == null)
        return {
          text: "",
          value: ""
        };

      if (typeof valor === 'string')
        return {
          text: this.form.participanteClienteNome || "",
          value: this.form.participanteClienteId || ""
        };

      return valor;
    }
  },
  watch: {
    'form.tipoDesconto': {
      handler() {
        this.alteraTituloHeaderDesconto();
      },
      immediate: true,
    },
    tamanhoOrcamentoItemDetalhe: {
      handler() {
        this.atualizarValoresItens();
      },
    },
    instrumento: [],
    'form.participanteClienteNome': {
      handler() {
        console.log("aquiiii", this.form);
      },
      immediate: true,
    }
  },
  mounted() {
    this.alteraTituloHeaderDesconto();
    this.atualizarValoresItens();
  },
  methods: {
    verificarItemTotal(item) {
      let instrumento = this.form.orcamentoItem.find((i) => i.id == item.id)

      if (item.orcamentoItemDetalhe.some((i) => i.flagItemCortesia)) {
        return true
      }
      if (item.orcamentoItemDetalhe.some((i) =>
          instrumento.orcamentoItemDetalhe.some((o) =>
              o?.servico?.desconto !== undefined && i.id == o.id && o?.servico?.desconto > i?.desconto
          )
      )) {
        return true
      }
      if (item.orcamentoItemDetalhe.some((i) =>
          instrumento.orcamentoItemDetalhe.some((o) =>
              o?.servico?.desconto !== undefined && i.id == o.id && o?.servico?.desconto < i?.desconto
          )
      )) {
        return true
      }
      if (item.orcamentoItemDetalhe.some((i) =>
          instrumento.orcamentoItemDetalhe.some((o) =>
              (o?.servico?.valorServico !== undefined && i.id == o.id && o?.servico?.valorServico > i?.valorUnitario
              && o?.servico?.valorServico !== i?.valorUnitario) || (i.item != null && o?.item?.valorVenda > i?.valorUnitario)
          )
      )) {
        return true
      }
      if (item.orcamentoItemDetalhe.some((i) =>
          instrumento.orcamentoItemDetalhe.some((o) =>
              (o?.servico?.valorServico !== undefined && i.id == o.id && o?.servico?.valorServico < i?.valorUnitario
              && o?.servico?.valorServico !== i?.valorUnitario) || (i.item != null && o?.item?.valorVenda < i?.valorUnitario)
          )
      )) {
        return true
      }
      if ((this.form.ordemServicoObj != undefined || this.form.ordemServicoObj != null)
      && item.orcamentoItemDetalhe.some((i) =>
          this.form.ordemServicoObj.instrumentos.some((o) =>
          o?.analiseTecnica?.prazoEntregaEmDias !== undefined && o?.analiseTecnica?.prazoEntregaEmDias < i.prazoEntrega))) {
        return true
      }

      if ((this.form.ordemServicoObj != undefined || this.form.ordemServicoObj != null)
      && item.orcamentoItemDetalhe.some((i) =>
          this.form.ordemServicoObj.instrumentos.some((o) =>
          o?.analiseTecnica?.prazoEntregaEmDias != undefined && o?.analiseTecnica?.prazoEntregaEmDias > i.prazoEntrega))) {
        return true
      }

      return false // Mensagem padrão
    },
    getTooltipMessage(item) {
      let instrumento = this.form.orcamentoItem.find((i) => i.id == item.id)


      if (item.orcamentoItemDetalhe.some((i) => i.flagItemCortesia)) {
        return this.$t('modulos.orcamentos.formulario.existe_servico_peca_cortesia');
      }
      if (item.orcamentoItemDetalhe.some((i) =>
          instrumento.orcamentoItemDetalhe.some((o) =>
              o?.servico?.desconto !== undefined && i.id == o.id && o?.servico?.desconto < i?.desconto
          )
      )) {
        return this.$t('modulos.orcamentos.formulario.desconto_acima_esperado')
      }
      if (item.orcamentoItemDetalhe.some((i) =>
          instrumento.orcamentoItemDetalhe.some((o) =>
              (o?.servico?.valorServico !== undefined && i.id == o.id && o?.servico?.valorServico > i?.valorUnitario
              && o?.servico?.valorServico !== i?.valorUnitario) || (i.item != null && o?.item?.valorVenda > i?.valorUnitario)
          )
      )) {
        return this.$t('modulos.orcamentos.formulario.valor_abaixo_esperado')
      }
      if (item.orcamentoItemDetalhe.some((i) =>
          instrumento.orcamentoItemDetalhe.some((o) =>
              (o?.servico?.valorServico !== undefined && i.id == o.id && o?.servico?.valorServico < i?.valorUnitario
              && o?.servico?.valorServico !== i?.valorUnitario) || (i.item != null && o?.item?.valorVenda < i?.valorUnitario)
          )
      )) {
        return this.$t('modulos.orcamentos.formulario.valor_acima_esperado')
      }
      if ((this.form.ordemServicoObj != undefined || this.form.ordemServicoObj != null)
      && item.orcamentoItemDetalhe.some((i) =>
          this.form.ordemServicoObj.instrumentos.some((o) =>
          o?.analiseTecnica?.prazoEntregaEmDias !== undefined && o?.analiseTecnica?.prazoEntregaEmDias < i.prazoEntrega))) {
        return this.$t('modulos.orcamentos.formulario.prazo_acima_selecionado')
      }

      if ((this.form.ordemServicoObj != undefined || this.form.ordemServicoObj != null)
      && item.orcamentoItemDetalhe.some((i) =>
          this.form.ordemServicoObj.instrumentos.some((o) =>
          o?.analiseTecnica?.prazoEntregaEmDias != undefined && o?.analiseTecnica?.prazoEntregaEmDias > i.prazoEntrega))) {
        return this.$t('modulos.orcamentos.formulario.prazo_abaixo_selecionado')
      }

      return this.$t('modulos.orcamentos.formulario.valor_total_item_detalhe_preenchido'); // Mensagem padrão
    },
    limparOrcamentoConsulta(item) {
      item.orcamentoItemInstrumento[0].orcamentoConsulta = null;
      item.orcamentoItemInstrumento[0].flagFinalizarOrcamentoConsulta = false;

      item.orcamentoItemDetalhe?.forEach((detalhe) => {
        if (detalhe) detalhe.tipoAprovacao = 'Cliente';
      });
    },
    deveMostrarIconeAguardandoAprovacaoItem(item) {
      if (this.form.status != 'AguardandoAprovacao') return false;

      item.orcamentoItemDetalhe.forEach((detalhe) => {
        detalhe.aguardandoAprovacao =
          this.deveMostrarIconeAguardandoAprovacao(detalhe);
      });
      const bool = item.orcamentoItemDetalhe.some(
        (detalhe) => detalhe.aguardandoAprovacao
      );
      return bool;
    },
    deveMostrarIconeItemOrcamento() {
      const situacoesOrcamento = [
        'Aprovado',
        'Reprovado',
        'AprovadoParcialmente',
        'Faturado',
        'AguardandoAprovacao',
      ];
      return situacoesOrcamento.includes(this.form.status);
    },
    deveMostrarIconeAguardandoAprovacao(itemDetalhe) {
      if (this.form.status != 'AguardandoAprovacao') return false;

      const teveAcaoServicos = this.form.aprovacoes.some((el) =>
        this.situacoesServicos.includes(el.tipo)
      );
      const teveAcaoPecas = this.form.aprovacoes.some((el) =>
        this.situacoesPecas.includes(el.tipo)
      );

      if (itemDetalhe.servico && teveAcaoServicos) return false;
      if (itemDetalhe.item && teveAcaoPecas) return false;

      return true;
    },
    deveMostrarIconeAprovacao(itemDetalhe) {
      const situacoesOrcamento = [
        'Aprovado',
        'Reprovado',
        'AprovadoParcialmente',
        'Faturado',
      ];

      if (situacoesOrcamento.includes(this.form.status)) return true;

      if (this.form.status != 'AguardandoAprovacao') return false;

      const teveAcaoServicos = this.form.aprovacoes.some((el) =>
        this.situacoesServicos.includes(el.tipo)
      );
      const teveAcaoPecas = this.form.aprovacoes.some((el) =>
        this.situacoesPecas.includes(el.tipo)
      );

      if (itemDetalhe.servico && teveAcaoServicos) return true;
      if (itemDetalhe.item && teveAcaoPecas) return true;

      return false;
    },
    deveMostrarTooltipAnaliseCritica(itemDetalhe) {
      const ac = itemDetalhe.analiseCritica;
      const bool =
        ac?.desconto?.flagTooltip ||
        ac?.valor?.flagTooltip ||
        ac?.horas?.flagTooltip ||
        ac?.foraContrato?.flagTooltip ||
        !ac?.foraContrato;
      return !!bool;
    },
    abrirOrcamentoAba(orcamento) {
      const url_base = window.location.origin;

      window.open(`${url_base}/cadastro/orcamentos/${orcamento.value}/true`);
    },
    montarTooltipAnaliseCritica(itemDetalhe) {
      const ac = itemDetalhe.analiseCritica;
      const simboloDesconto =
        this.form.tipoDesconto == 'Percentual' ? '%' : 'R$';
      let tooltips = [];
      if (ac.desconto && ac.desconto.flagTooltip)
        tooltips.push(
          `Desconto (${simboloDesconto} ${helpers.formatarNumeroComPrecisao(
            ac.desconto.valor
          )}) maior que o liberado (${simboloDesconto} ${helpers.formatarNumeroComPrecisao(
            ac.desconto.valorPadrao
          )})`
        );
      if (ac.valor && ac.valor.flagTooltip)
        tooltips.push(
          `Valor (R$ ${helpers.formatarNumeroComPrecisao(
            ac.valor.valor
          )}) maior que o liberado (R$ ${helpers.formatarNumeroComPrecisao(
            ac.valor.valorPadrao
          )})`
        );
      if (ac.horas && ac.horas.flagTooltip)
        tooltips.push(
          `Horas (${ac.horas.valor}h) maior que o liberado (${ac.horas.valorPadrao}h)`
        );
      if (ac.foraContrato && ac.foraContrato.flagTooltip) {
        if (itemDetalhe.item) {
          tooltips.push(`Peça fora de contrato`);
        } else {
          tooltips.push(`Serviço extra`);
        }
      }
      return tooltips;
    },
    alteraTituloHeaderDesconto() {
      if (this.form.tipoDesconto == 'Percentual') {
        this.tabela.colunas[6].text = this.$t(
          'modulos.orcamentos.formulario.desconto_icone_percent'
        );
      } else {
        this.tabela.colunas[6].text = this.$t(
          'modulos.orcamentos.formulario.desconto'
        );
      }
    },

    trocaSpanColocaFocoDescricao(numItem) {
      if (this.visualizacao) return;
      this.atualizaSpanInputDescricao(numItem);
      setTimeout(() => {
        this.$refs['inputDescricao' + numItem].focus();
      }, 300);
    },
    atualizaSpanInputDescricao(numItem) {
      if (this.visualizacao) return;
      this.form.orcamentoItem.map((item) => {
        if (item.numeroItem == numItem) {
          item.trocaSpanInputDescricao = !item.trocaSpanInputDescricao;
        }
      });
      this.keyAtualiza++;
    },
    abrirModalVisualizarUltimosPrecosOrcados() {
      this.$refs['modal-visualizar-ultimos-precos'].abrirModal();
    },
    trocaSpanColocaFocoPrazo(numItem) {
      this.atualizaSpanInputPrazo(numItem);
      setTimeout(() => {
        this.$refs['inputPrazo' + numItem].$el.children[0].focus();
      }, 300);
    },
    atualizaSpanInputPrazo(numItem) {
      this.form.orcamentoItem.map((item) => {
        if (item.numeroItem == numItem) {
          item.trocaSpanInputPrazo = !item.trocaSpanInputPrazo;
        }
      });
      this.keyAtualiza++;
    },
    trocaSpanColocaFocoQuantidade(numItem) {
      if (this.visualizacao) return;
      this.atualizaSpanInputQuantidade(numItem);
      setTimeout(() => {
        this.$refs['inputQuantidade' + numItem].$el.children[0].focus();
      }, 300);
    },
    atualizaSpanInputQuantidade(numItem) {
      if (this.visualizacao) return;
      this.form.orcamentoItem.map((item) => {
        if (item.numeroItem == numItem) {
          item.trocaSpanInputQuantidade = !item.trocaSpanInputQuantidade;
        }
      });
      this.keyAtualiza++;
    },
    trocaSpanColocaFocoValorUnitario(numItem) {
      this.atualizaSpanInputValorUnitario(numItem);
      setTimeout(() => {
        this.$refs['inputValorUnitario' + numItem].$el.children[0].focus();
      }, 300);
    },
    atualizaSpanInputValorUnitario(numItem) {
      this.form.orcamentoItem.map((item) => {
        if (item.numeroItem == numItem) {
          item.trocaSpanInputValorUnitario = !item.trocaSpanInputValorUnitario;
        }
      });
      this.keyAtualiza++;
    },
    trocaSpanColocaFocoValorTotal(numItem) {
      this.atualizaSpanInputValorTotal(numItem);
      setTimeout(() => {
        this.$refs['inputValorTotal' + numItem].$el.children[0].focus();
      }, 300);
    },
    atualizaSpanInputValorTotal(numItem) {
      this.form.orcamentoItem.map((item) => {
        if (item.numeroItem == numItem) {
          item.trocaSpanInputValorTotal = !item.trocaSpanInputValorTotal;
        }
      });
      this.keyAtualiza++;
    },
    trocaSpanColocaFocoDesconto(numItem) {
      this.atualizaSpanInputDesconto(numItem);
      setTimeout(() => {
        this.$refs['inputDesconto' + numItem].$el.children[0].focus();
      }, 300);
    },
    atualizaSpanInputDesconto(numItem) {
      this.form.orcamentoItem.map((item) => {
        if (item.numeroItem == numItem) {
          item.trocaSpanInputDesconto = !item.trocaSpanInputDesconto;
        }
      });
      this.keyAtualiza++;
    },
    alterarPrazoServicos(item, numItem) {
      this.atualizaSpanInputPrazo(numItem);
      this.keyAtualiza++;
      this.trocaSpanInputPrazo = !this.trocaSpanInputPrazo;
      item.orcamentoItemDetalhe?.forEach(
        (servico) => (servico.prazoEntrega = item.prazoEntrega)
      );
    },
    manipulaModalPesquisaPecas(pecas = '', type = '') {
      this.showModalPecas = false;

      if (type === 'add') {
        this.form.orcamentoItem.map((item) => {
          if (
            item.numeroItem == this.numeroItemPecasSelecionadas &&
            pecas.selected.length
          ) {
            pecas.selected.map((itemPeca) => {
              item.orcamentoItemDetalhe.push({
                idItem: itemPeca.id,
                codigo: itemPeca.codigo,
                descricao: itemPeca.descricao ? itemPeca.descricao : '',
                prazoEntrega: this.prazoEntregaPadrao ?? item.prazoEntrega,
                quantidade: 1,
                valorUnitario: itemPeca.valorVenda,
                valorTotal: itemPeca.valorVenda,
                desconto: 0,
                quantidadeAprovada: 0,
                flagItemCortesia: item.flagItemCortesia ? true : false,
                numeroItem: this.obterProximoNumeroItem(item.orcamentoItemDetalhe),
                trocaSpanInputOrcamentoItemDetalhe: false,
                itemId: itemPeca.id,
                tipo: 'peça',
                tipoAprovacao: 'Cliente',
              });
              if (item.flagItemCortesia) this.selecionarItemCortesia(item);
            });
          }
        });
      }
    },
    definirIconeAdicionadoRemovido: function (item) {
      let flag = false;
      if (item.orcamentoItemInstrumento?.length != 0)
        flag = item.orcamentoItemInstrumento[0].flagAdicionadoCliente;
      if (!flag)
        return {
          icon: '$successCircleOutline',
          color: 'primary-success-700--text',
          tooltip: this.$t('modulos.contrato.instrumento_validado'),
        };
      return {
        icon: '$plusCircleOutline',
        color: 'warning--text',
        tooltip: this.$t('modulos.contrato.instrumento_adicionado'),
      };
    },
    montaDescricaoItemOrcamento: function () {
      console.log('numeroItem', this.numeroItem);
      console.log('numeroItem', this.numeroItemOrcamento);
      console.log('numeroItemTipoServicoCalibracaoSelecionados', this.numeroItemTipoServicoCalibracaoSelecionados);
      console.log('numeroItemTipoServicoManutencaoSelecionados', this.numeroItemTipoServicoManutencaoSelecionados);
      console.log('numeroItemPecasSelecionadas', this.numeroItemPecasSelecionadas);
      this.nomeServicoManutencao = '';
      this.form.orcamentoItem.forEach((item) => {
        this.nomeServicoManutencao = item.orcamentoItemDetalhe.find(
          (itemDetalhe) => itemDetalhe.tipoServico == 'Manutencao'
        )?.nomeServico
          ? item.orcamentoItemDetalhe.find(
            (itemDetalhe) => itemDetalhe.tipoServico == 'Manutencao'
          )?.nomeServico
          : '';
      });

      setTimeout(() => {
        this.form.orcamentoItem
          .filter(w => this.numeroItemTipoServicoCalibracaoSelecionados && w.numeroItem == this.numeroItemTipoServicoCalibracaoSelecionados
            || this.numeroItemTipoServicoManutencaoSelecionados && w.numeroItem == this.numeroItemTipoServicoManutencaoSelecionados
            || this.numeroItemPecasSelecionadas && w.numeroItem == this.numeroItemPecasSelecionadas
          )
          .map((item) => {
            console.log('item.descricaoInicial', item.descricao);
            console.log('item.numeroItem', item.numeroItem);

            item.descricao = '';
            this.calibracaoCampoOuLaboratorio = '';
            this.primeiroItemCalibracao = item.orcamentoItemDetalhe.find(
              (itemDetalhe) => {
                return itemDetalhe.tipoServico == 'Calibracao';
              }
            );
            item.orcamentoItemDetalhe.map(() => {
              if (this.primeiroItemCalibracao?.localExecucao == 'Laboratório') {
                this.calibracaoCampoOuLaboratorio = 'CALIBRAÇÃO';
              } else this.calibracaoCampoOuLaboratorio = 'CALIBRAÇÃO EM CAMPO';

              if (
                !this.primeiroItemCalibracao?.tipoServico &&
                this.nomeServicoManutencao
              ) {
                item.descricao = this.nomeServicoManutencao;
              } else if (this.primeiroItemCalibracao) {
                const manutencoesNome = item.orcamentoItemDetalhe
                  .filter((servico) => servico.tipoServico == 'Manutencao')
                  .map((servico) => servico.nomeServico)
                  .join('/');

                const instrumentosNomes = item.instrumentosNomes?.length
                  ? `- COD: ${item.instrumentosNomes.join('; ')}`
                  : '';

                item.descricao = `${this.primeiroItemCalibracao?.nomeServico ?? ''
                  } (${this.primeiroItemCalibracao.amplitudeMinima ?? ''} a ${this.primeiroItemCalibracao?.amplitudeMaxima ?? ''
                  }) ${this.primeiroItemCalibracao?.unidadeMedidaNome ?? ''
                  }  ${instrumentosNomes} - ${this.calibracaoCampoOuLaboratorio
                  }/${manutencoesNome} ${this.primeiroItemCalibracao.pontos
                    ? 'Em ' + this.primeiroItemCalibracao.pontos + ' Pontos'
                    : ''
                  } ${this.primeiroItemCalibracao.descricaoCompleta
                    ? this.primeiroItemCalibracao.descricaoCompleta
                    : ''
                  }`.trim();
                console.log('item.descricaoFinal', item.descricao);
              }
            });
          });
      }, 600);
    },
    abreModalPecas(item) {
      const {
        numeroItem,
        orcamentoItemDetalhe,
        instrumentosSelecionadosColuna,
      } = item;
      this.numeroItemPecasSelecionadas = numeroItem;
      // this.showModalPecas = true;
      const pecasSelecionadas = orcamentoItemDetalhe
        ?.filter((item) => item.tipo == 'peça')
        ?.map((item) => {
          return {
            id: item.idItem,
            index: numeroItem,
            indexItem: item.numeroItem - 1,
          };
        });

      this.instrumentosSelecionadosIds = instrumentosSelecionadosColuna?.map(
        (instrumento) => instrumento.id
      );

      setTimeout(() => {
        this.$refs['pecas-modal'].abrirModal(pecasSelecionadas);
      }, 100);
    },
    abreModalTipoServicosManutencao(item) {
      const {
        numeroItem,
        orcamentoItemDetalhe,
        instrumentosSelecionadosColuna,
      } = item;
      this.numeroItemTipoServicoManutencaoSelecionados = numeroItem;

      const servicoManutencaoSelecionado = orcamentoItemDetalhe
        ?.filter((item) => item.tipoServico == 'Manutencao')
        ?.map((item) => {
          return {
            id: item.idItem,
            index: numeroItem,
            indexItem: item.numeroItem - 1,
          };
        });

      this.instrumentosSelecionadosIds = instrumentosSelecionadosColuna?.map(
        (instrumento) => instrumento.id
      );
      setTimeout(() => {
        this.$refs['servico-manutencao-modal'].abrirModal(
          servicoManutencaoSelecionado
        );
      }, 100);
    },
    async manipulaModalPesquisaTipoServicosManutencao(
      tipoServicoManutencao = '',
      type = ''
    ) {
      this.showModalTipoServicoManutencao = false;

      if (type === 'add') {
        this.form.orcamentoItem.map((item) => {
          if (
            item.numeroItem ==
            this.numeroItemTipoServicoManutencaoSelecionados &&
            tipoServicoManutencao.selected.length
          ) {
            tipoServicoManutencao.selected.map(async (itemTipoServico) => {
              let quantidadePontos = 0;
              if (item.orcamentoItemInstrumento) {
                await this.validaPrecoServico(
                  itemTipoServico,
                  item.orcamentoItemInstrumento[0]?.instrumentoId
                );
                if (item.orcamentoItemInstrumento[0]?.quantidadePontos) {
                  quantidadePontos =
                    item.orcamentoItemInstrumento[0]?.quantidadePontos;
                }
              }
              item.orcamentoItemDetalhe.push({
                idItem: itemTipoServico.id,
                codigo: itemTipoServico.codigo,
                descricao: itemTipoServico.nome,
                minimoPontos: itemTipoServico.minimoPontos,
                valorPonto: itemTipoServico.valorPonto,
                descricaoPrincipal: ` ${itemTipoServico.nome} ${itemTipoServico.descricao}`,
                nomeServico: `${itemTipoServico.nome}`,
                trocaSpanInputOrcamentoItemDetalhe: false,
                prazoEntrega: this.prazoEntregaPadrao ?? item.prazoEntrega,
                quantidade: 1,
                valorUnitario: this.precoServicoContrato
                  ? this.precoServicoContrato
                  : itemTipoServico.valorServico +
                  this.calcularValorPontosExtrasVariaveis(
                    quantidadePontos,
                    itemTipoServico.minimoPontos,
                    itemTipoServico.valorPonto
                  ),
                valorTotal: this.precoServicoContrato
                  ? this.precoServicoContrato
                  : itemTipoServico.valorServico,
                desconto: itemTipoServico.desconto
                  ? itemTipoServico.desconto
                  : 0,
                quantidadeAprovada: 0,
                flagItemCortesia: item.flagItemCortesia ? true : false,
                numeroItem: this.obterProximoNumeroItem(item.orcamentoItemDetalhe),
                servicoId: itemTipoServico.id,
                tipo: 'serviço',
                tipoServico: itemTipoServico.tipoServico,
                tipoAprovacao: 'Cliente',
              });
              if (item.flagItemCortesia) this.selecionarItemCortesia(item);
            });
          }
        });

        this.montaDescricaoItemOrcamento();
      }
    },
    abreModalTipoServicosCalibracao(item) {
      const {
        numeroItem,
        orcamentoItemDetalhe,
        instrumentosSelecionadosColuna,
      } = item;
      this.numeroItemTipoServicoCalibracaoSelecionados = numeroItem;

      const servicoCalibracaoSelecionado = orcamentoItemDetalhe
        ?.filter((item) => item.tipoServico == 'Calibracao')
        ?.map((item) => {
          return {
            id: item.idItem,
            index: numeroItem,
            indexItem: item.numeroItem - 1,
          };
        });
      this.instrumentosSelecionadosIds = instrumentosSelecionadosColuna?.map(
        (instrumento) => instrumento.id
      );

      setTimeout(() => {
        this.$refs['servico-calibracao-modal'].abrirModal(
          servicoCalibracaoSelecionado
        );
      }, 100);
    },
    async validaPrecoServico(servico, instrumentoId) {
      if (servico || instrumentoId) return; //verificar endpoint
      if (instrumentoId) {
        this.precoServicoContrato = null;
        let params = {
          participanteId: this.form.participanteClienteId,
          instrumentoId: instrumentoId,
          servicoId: servico.id,
        };

        await ContratoService.buscarServicoContrato(params)
          .then((res) => {
            if (res.data) {
              this.precoServicoContrato = res.data.valorServico;
            }
          })
          .catch(() => {
            this.toastAlerta(
              this.$t(`geral.erros.instrumento_contrato_associado`)
            );
          });
      }
    },
    async manipulaModalPesquisaTipoServicosCalibracao(
      tipoServicoCalibracao = '',
      type = ''
    ) {
      this.showModalTipoServicoCalibracao = false;

      if (type === 'add') {
        this.form.orcamentoItem.map((item) => {
          if (
            item.numeroItem ==
            this.numeroItemTipoServicoCalibracaoSelecionados &&
            tipoServicoCalibracao.selected.length
          ) {
            tipoServicoCalibracao.selected.map(async (itemTipoServico) => {
              let quantidadePontos = 0;
              if (item.orcamentoItemInstrumento) {
                //enviando o item.orcamentoItemInstrumento[0].instrumentoId até um retorno de definição do cliente
                await this.validaPrecoServico(
                  itemTipoServico,
                  item.orcamentoItemInstrumento[0]?.instrumentoId
                );
                if (item.orcamentoItemInstrumento[0]?.quantidadePontos) {
                  quantidadePontos =
                    item.orcamentoItemInstrumento[0]?.quantidadePontos;
                }
              }

              item.orcamentoItemDetalhe.push({
                idItem: itemTipoServico.id,
                codigo: itemTipoServico.codigo,
                descricao: itemTipoServico.nome,
                descricaoPrincipal: '',
                tipoAprovacao: 'Cliente',
                minimoPontos: itemTipoServico.minimoPontos,
                valorPonto: itemTipoServico.valorPonto,
                nomeServico: `${itemTipoServico.nome}`,
                amplitudeMinima: `${itemTipoServico.amplitudeMinima}`,
                amplitudeMaxima: `${itemTipoServico.amplitudeMaxima}`,
                unidadeMedidaNome: `${itemTipoServico.unidadeMedida?.nome}`,
                pontos: `${itemTipoServico.minimoPontos}`,
                descricaoCompleta: `- ${itemTipoServico.descricao}`,
                localExecucao: `${itemTipoServico.localExecucao.nome}`,
                tipoCalibracao: `${itemTipoServico.tipoCalibracao.nome}`,
                trocaSpanInputOrcamentoItemDetalhe: false,
                prazoEntrega: this.prazoEntregaPadrao ?? item.prazoEntrega,
                quantidade: 1,
                valorUnitario:
                  itemTipoServico.valorServico +
                  this.calcularValorPontosExtrasVariaveis(
                    quantidadePontos,
                    itemTipoServico.minimoPontos,
                    itemTipoServico.valorPonto
                  ),
                valorTotal: this.precoServicoContrato
                  ? this.precoServicoContrato
                  : itemTipoServico.valorServico,
                desconto: itemTipoServico.desconto
                  ? itemTipoServico.desconto
                  : 0,
                quantidadeAprovada: 0,
                flagItemCortesia: item.flagItemCortesia ? true : false,
                numeroItem: this.obterProximoNumeroItem(item.orcamentoItemDetalhe),
                servicoId: itemTipoServico.id,
                tipo: 'serviço',
                tipoServico: itemTipoServico.tipoServico,
              });

              if (item.flagItemCortesia) this.selecionarItemCortesia(item);
            });
          }
        });

        this.montaDescricaoItemOrcamento();
      }
    },
    removerViaModal(itens) {
      itens?.forEach((item, index) => {
        const buscarIndexParaRemover = this.form.orcamentoItem[
          item.index - 1
        ].orcamentoItemDetalhe.findIndex(
          (itemDetalhe) => itemDetalhe.idItem == item.id
        );

        if (buscarIndexParaRemover != -1) {
          this.form.orcamentoItem[item.index - 1].orcamentoItemDetalhe.splice(
            buscarIndexParaRemover,
            1
          );

          this.calcularLinhaPrincipal(item.index);
          if (index == itens.length - 1) {
            this.montaDescricaoItemOrcamento();
            this.calculaValorTotalGeral(item.index);
          }
        }
      });
    },
    removerInstrumento(indexItem, indexInstrumento) {
      this.form.orcamentoItem.map((item, index) => {
        if (index == indexItem) {
          item.orcamentoItemInstrumento.splice(indexInstrumento, 1);
          item.instrumentosSelecionadosColuna.splice(indexInstrumento, 1);
          item.instrumentosNomes.splice(indexInstrumento, 1);
        }
      });

      this.keyAtualiza++;
    },
    abreModalEditarInstrumento(item, nome, index, indexInstrumento) {
      this.indexAtualInstrumento = index;
      let instrumento = item.orcamentoItemInstrumento?.find(
        (el) => el.nome == nome
      );
      if (!instrumento)
        instrumento = item.instrumentosSelecionadosColuna?.find(
          (el) => el.codigoTag == nome
        );
        this.editarInstrumentoId = instrumento?.instrumentoId ?? instrumento?.id;
      this.indexInstrumentoNome = indexInstrumento;
      if (!instrumento)
        return console.error(
          'Não foi possível encontrar o instrumento para edição'
        );
      this.$refs['modal-edicao-instrumento'].abrirModal();
    },
    abreModalInstrumentos(index) {
      this.indexAtualInstrumento = index;
      this.$refs['instrumento-tipo-modal'].abrirModal();

      this.instrumentosSelecionados = [];
      this.form.orcamentoItem.map((item, indexOrcamento) => {
        if (indexOrcamento == this.indexAtualInstrumento) {
          if (indexOrcamento == this.indexAtualInstrumento) {
            this.instrumentosSelecionados = item.instrumentosSelecionadosColuna;
          }
        }
      });
    },
    inserirInstrumentosOrcamento(instrumentos = '', type = '') {
      if (type === 'add') {
        this.form.orcamentoItem.map((item, index) => {
          if (index == this.indexAtualInstrumento) {
            item.instrumentosNomes = [];
            item.orcamentoItemInstrumento = [];
          }
        });

        this.form.orcamentoItem.map((item, index) => {
          if (index == this.indexAtualInstrumento) {
            instrumentos.selected.map((itemInstrumentos) => {
              if (
                !item.instrumentosNomes.includes(itemInstrumentos.codigoTag)
              ) {
                item.instrumentosNomes.push(itemInstrumentos.codigoTag);
                item.orcamentoItemInstrumento.push({
                  instrumentoId: itemInstrumentos.id,
                  quantidadePontos: itemInstrumentos.quantidadePontos,
                });
              }
              item.instrumentosSelecionadosColuna = [...instrumentos.selected];
            });
          }
        });
      }
    },
    manipulaModalPesquisaInstrumentos(instrumentos = '', type = '') {
      if (instrumentos?.selected?.length == 1) {
        this.inserirInstrumentosOrcamento(instrumentos, type);
        return;
      }
      this.confirmarAgruparInstrumentos()
        .then(() => {
          this.inserirInstrumentosOrcamento(instrumentos, type);
        })
        .catch(() => {
          if (type === 'add') {
            this.form.orcamentoItem.splice(this.indexAtualInstrumento, 1);

            instrumentos.selected.map((item) => {
              this.form.orcamentoItem.push({
                numeroItem: this.obterProximoNumeroItem(this.form.orcamentoItem),
                orcamentoItemInstrumento: [{ instrumentoId: item.id }],
                descricao: '',
                prazoEntrega: this.prazoEntregaPadrao,
                quantidade: 1,
                valorUnitario: 0,
                valorTotal: 0,
                desconto: 0,
                instrumentosNomes: [item.codigoTag],
                instrumentosSelecionadosColuna: [...instrumentos.selected],
                orcamentoItemDetalhe: [],
                valorTotalCalculadoGeral: 0,
                quantidadeAprovada: 0,
                flagItemCortesia: false,
                dataAprovacao: null,
              });
            });
          }
        });
      this.keyAtualiza++;
    },
    obterProximoNumeroItem(array) {
      if (!array || array.length === 0) return 1;

      return array.reduce((max, item) =>
        item.numeroItem > max ? item.numeroItem : max,
        array[0].numeroItem
      ) + 1;
    },
    adicionaItemOrcamento() {
      this.form.orcamentoItem.push({
        numeroItem: this.obterProximoNumeroItem(this.form.orcamentoItem),
        orcamentoItemInstrumento: null,
        trocaSpanInputDescricao: false,
        descricao: '',
        prazoEntrega: this.prazoEntregaPadrao,
        trocaSpanInputPrazo: false,
        quantidade: 1,
        trocaSpanInputQuantidade: false,
        valorUnitario: 0,
        trocaSpanInputValorUnitario: false,
        valorTotal: 0,
        trocaSpanInputValorTotal: false,
        desconto: 0,
        trocaSpanInputDesconto: false,
        instrumentosNomes: [],
        instrumentosSelecionadosColuna: [],
        orcamentoItemDetalhe: [],
        valorTotalCalculadoGeral: 0,
        quantidadeAprovada: 0,
        dataAprovacao: null,
        orcamentoConsulta: null,
        flagFinalizarOrcamentoConsulta: false,
        flagItemCortesia: false,
      });
      this.expanded.push({
        numeroItem: this.form.orcamentoItem.length,
        orcamentoItemInstrumento: null,
        descricao: '',
        prazoEntrega: this.prazoEntregaPadrao,
        quantidade: 1,
        valorUnitario: 0,
        valorTotal: 0,
        desconto: 0,
        instrumentosNomes: [],
        instrumentosSelecionadosColuna: [],
        orcamentoItemDetalhe: [],
        valorTotalCalculadoGeral: 0,
        quantidadeAprovada: 0,
        dataAprovacao: null,
        flagItemCortesia: false,
      });
    },
    duplicar(item) {
      let itemDuplicar = JSON.parse(JSON.stringify(item));
      this.form.orcamentoItem.push({
        ...itemDuplicar,
        numeroItem: this.renumeracaoItens++,
      });

      this.recalculaValorTotal();
    },
    excluir(index) {
      this.renumeracaoItens = 1;
      this.expanded.splice(index, 1);
      this.form.orcamentoItem.splice(index, 1);
      this.form.orcamentoItem.map((item) => {
        item.numeroItem = this.renumeracaoItens++;
      });

      this.recalculaValorTotal();
    },
    recalculaValorTotal() {
      this.form.valorTotalItens = this.form.orcamentoItem.reduce(
        (total, item) => {
          let valorTotalItem = item.valorUnitario * item.quantidade;
          valorTotalItem += this.calcularPontosExtras(item);

          return total + valorTotalItem;
        },
        0
      );
      this.keyAtualiza++;
    },
    selecionarItemCortesia(item) {
      item.orcamentoItemDetalhe.forEach((detalhe) => {
        detalhe.flagItemCortesia = item.flagItemCortesia;
        detalhe.valorUnitario = 0;
        detalhe.valorDesconto = 0;
        detalhe.valorTotal = 0;
      });
      this.calcularLinhaPrincipal(item.numeroItem);
    },
    selecionarDetalheItemCortesia(item, detalhe) {
      detalhe.valorUnitario = 0;
      detalhe.valorDesconto = 0;
      detalhe.valorTotal = 0;

      const todosTemFlagItemCortesia = item.orcamentoItemDetalhe.every(
        (detalhe) => detalhe.flagItemCortesia
      );

      if (todosTemFlagItemCortesia) {
        item.flagItemCortesia = true;
      } else {
        item.flagItemCortesia = false;
      }

      this.calcularLinhaPrincipal(item.numeroItem);
    },
    removerTipoServicosEPecas(numeroItem, index, item) {
      this.form.orcamentoItem.map((item) => {
        if (item.numeroItem == numeroItem) {
          item.orcamentoItemDetalhe.map((itemDetalhes, indexDetalhes) => {
            if (index == indexDetalhes) {
              item.orcamentoItemDetalhe.splice(index, 1);
            }
          });
        }
      });
      this.montaDescricaoItemOrcamento();
      this.calcularLinhaPrincipal(item.numeroItem);
    },
    calculaValoresTotalItemPrincipal(itemNumero) {
      this.form.orcamentoItem.forEach((item) => {
        if (
          item.numeroItem == itemNumero &&
          item.quantidade &&
          item.valorUnitario
        ) {
          let valorItemQtd =
            Number(item.quantidade) * Number(item.valorUnitario);
          if (this.form.tipoDesconto == 'Percentual') {
            valorItemQtd =
              valorItemQtd - valorItemQtd * ((item?.desconto || 0) / 100);
          } else {
            valorItemQtd = valorItemQtd - (item?.desconto || 0);
          }

          item.valorTotal = valorItemQtd;
        }
      });

      this.calculaValorFinal();
    },
    calculaValorTotal(numeroItem, index) {
      this.form.orcamentoItem.map((item) => {
        if (item.numeroItem == numeroItem) {
          item.valorTotalCalculadoGeral = 0;
          item.orcamentoItemDetalhe.map((itemDetalhes, indexDetalhes) => {
            if (
              index == indexDetalhes &&
              itemDetalhes.quantidade &&
              itemDetalhes.valorUnitario
            ) {
              let valorItemQtd =
                Number(itemDetalhes.quantidade) *
                Number(itemDetalhes.valorUnitario);
              if (this.form.tipoDesconto == 'Percentual') {
                valorItemQtd =
                  valorItemQtd -
                  valorItemQtd * ((itemDetalhes?.desconto || 0) / 100);
              } else {
                valorItemQtd = valorItemQtd - (itemDetalhes?.desconto || 0);
              }

              itemDetalhes.valorTotal = valorItemQtd;
            }
            if (itemDetalhes.valorTotal) {
              let calculoTotal =
                Number(item.valorTotalCalculadoGeral) +
                Number(itemDetalhes.valorTotal);
              item.valorTotalCalculadoGeral = calculoTotal;
              item.valorUnitario = calculoTotal;
            }
          });
        }
      });

      this.calculaValoresTotalItemPrincipal(numeroItem);
    },
    calculaValorTotalGeral(numeroItem) {
      this.form.orcamentoItem.map((item) => {
        if (item.numeroItem == numeroItem) {
          item.valorTotalCalculadoGeral = 0;
          item.orcamentoItemDetalhe.map((itemDetalhes) => {
            if (itemDetalhes.valorTotal) {
              let calculoTotal =
                Number(item.valorTotalCalculadoGeral) +
                Number(itemDetalhes.valorTotal);
              item.valorTotalCalculadoGeral = calculoTotal;
              item.valorUnitario = calculoTotal;
            }
          });
          if (item.orcamentoItemDetalhe?.length == 0) {
            item.valorTotalCalculadoGeral = 0;
            item.valorUnitario = 0;
            item.valorTotal = 0;
          }
        }
      });

      setTimeout(() => {
        this.calculaValoresTotalItemPrincipal(numeroItem);
      }, 200);
    },
    calculaValorFinal() {
      this.form.valorTotalItens = 0;
      this.form.valorTotalDesconto = 0;

      this.form.orcamentoItem.map((item) => {
        if (!item.desconto) item.desconto = 0;
        if (this.form.tipoDesconto != 'Percentual') {
          item.valorTotal = parseFloat(item.valorTotal);
          item.desconto = parseFloat(item.desconto);
          this.form.valorTotalItens =
            Number(this.form.valorTotalItens ?? 0) +
            Number(item.valorTotal ?? 0) -
            Number(item.desconto ?? 0);
        } else {
          item.valorTotal = parseFloat(item.valorTotal);
          item.desconto = parseFloat(item.desconto);
          this.descontoPercentual = item.desconto;
          if (item.desconto) {
            this.descontoPercentual = item.valorTotal * (item.desconto / 100);
          }
          this.form.valorTotalItens +=
            Number(item.valorTotal) - Number(this.descontoPercentual);
        }

        this.form.valorTotalDesconto += parseFloat(item.desconto);
      });
    },
    selecionarConteudo: function (event) {
      event.target.select();
    },
    calcularValorPontosExtrasVariaveis(
      quantidadePontosInstrumento,
      quantidadePontosServico,
      valorPontoExtraServico
    ) {
      if (quantidadePontosInstrumento <= quantidadePontosServico) {
        return 0;
      }

      let totalPontosExtras =
        quantidadePontosInstrumento - quantidadePontosServico;
      let valorPontosExtras = totalPontosExtras * valorPontoExtraServico;
      return valorPontosExtras;
    },
    calcularValorPontosExtras(orcamentoItemDetalhe, quantidadePontos) {
      let quantidadeMinimaPontos =
        orcamentoItemDetalhe.servico?.quantidadeMinimaPontos;

      if (!orcamentoItemDetalhe.servico) {
        quantidadeMinimaPontos = orcamentoItemDetalhe.minimoPontos;
      }

      if (quantidadePontos <= quantidadeMinimaPontos) {
        return 0;
      }

      let totalPontosExtras = quantidadePontos - quantidadeMinimaPontos;

      let valorPontoServico = orcamentoItemDetalhe.servico?.valorPonto;

      if (!orcamentoItemDetalhe.servico) {
        valorPontoServico = orcamentoItemDetalhe.valorPonto;
      }

      let valorPontosExtras = totalPontosExtras * valorPontoServico;

      return valorPontosExtras;
    },
    calcularPontosExtras(item) {
      let valorPontosExtras = 0;

      if (
        item.orcamentoItemInstrumento &&
        item.orcamentoItemInstrumento.length > 0 &&
        item.orcamentoItemDetalhe &&
        item.orcamentoItemDetalhe.length > 0
      ) {
        item.orcamentoItemInstrumento.forEach((instrumento) => {
          item.orcamentoItemDetalhe.forEach((detalhe) => {
            if (
              instrumento.quantidadePontos >
              detalhe.servico?.quantidadeMinimaPontos ||
              instrumento.quantidadePontos > detalhe.minimoPontos
            ) {
              this.totalPontosExtras =
                instrumento.quantidadePontos -
                detalhe.servico?.quantidadeMinimaPontos;

              if (!this.totalPontosExtras) {
                this.totalPontosExtras =
                  instrumento.quantidadePontos - detalhe.minimoPontos;
              }

              let valorPontoServico = detalhe.servico?.valorPonto;
              let valorPontosDetalhe = detalhe.valorPonto;

              if (!valorPontoServico) {
                valorPontoServico = valorPontosDetalhe;
              }
              valorPontosExtras = this.totalPontosExtras * valorPontoServico;
            }
          });
        });
      }

      return valorPontosExtras;
    },
    atualizarValoresItens: function () {
      this.form.orcamentoItem.forEach((item) => {
        item.orcamentoItemDetalhe.forEach((detalhe, indexDetalhe) => {
          this.calcularLinhasItens(item.numeroItem, indexDetalhe, item);
        });
      });
    },
    recalcularValorUnitarioItemInserido: function (
      numeroItem,
      indexItemDetalhe,
      item
    ) {
      const detalhes = [...item.orcamentoItemDetalhe];
      console.log('detalhes', detalhes);

      const linha = item.orcamentoItemDetalhe[indexItemDetalhe];

      let valorItemQtd = linha.valorUnitario || 0;

      if (linha.tipo == 'serviço') {
        let quantidadePontosInstrumento =
          item.orcamentoItemInstrumento[0]?.quantidadePontos || 0;

        valorItemQtd += this.calcularValorPontosExtras(
          linha,
          quantidadePontosInstrumento
        );
      }
      linha.valorUnitario = valorItemQtd;

      this.calcularLinhasItens(numeroItem, indexItemDetalhe, item);
    },
    calcularLinhasItens: function (numeroItem, indexItemDetalhe, item) {
      const linha = item.orcamentoItemDetalhe[indexItemDetalhe];

      let valorItemQtd = linha.valorUnitario || 0;

      linha.valorDesconto = 0;
      if (this.form.tipoDesconto == 'Percentual') {
        linha.valorDesconto = valorItemQtd * ((linha?.desconto || 0) / 100);
      } else {
        linha.valorDesconto = linha?.desconto || 0;
      }
      valorItemQtd = valorItemQtd - linha.valorDesconto;

      valorItemQtd = Number(linha.quantidade) * valorItemQtd;
      linha.valorTotal = valorItemQtd;

      this.calcularLinhaPrincipal(numeroItem);
    },
    calcularLinhaPrincipal: function (numeroItem) {
      if (numeroItem <= 0) return;
      const linhaPrincipal = this.form.orcamentoItem.find(
        (item) => item.numeroItem == numeroItem
      );

      const somatorioLinhas = linhaPrincipal.orcamentoItemDetalhe.reduce(
        (acc, linha) => {
          acc.valorUnitarioTotal +=
            (Number(linha?.valorUnitario) || 0) *
            (Number(linha?.quantidade) || 0);
          acc.valorTotal += Number(linha?.valorTotal) || 0;
          acc.maiorPrazo = Math.max(acc.maiorPrazo, linha?.prazoEntrega || 0);
          acc.valorTotalDesconto += Number(linha?.valorDesconto) || 0;
          return acc;
        },
        {
          valorUnitarioTotal: 0,
          valorTotal: 0,
          maiorPrazo: 0,
          valorTotalDesconto: 0,
        }
      );

      linhaPrincipal.valorUnitario = somatorioLinhas.valorUnitarioTotal;
      linhaPrincipal.valorTotal = somatorioLinhas.valorTotal;
      linhaPrincipal.prazoEntrega = somatorioLinhas.maiorPrazo;
      linhaPrincipal.desconto = somatorioLinhas.valorTotalDesconto;
      linhaPrincipal.valorTotal *= linhaPrincipal.quantidade;

      this.calcularTotalOrcamento();
    },
    calcularTotalOrcamento() {
      const valoresTotais = this.form.orcamentoItem.reduce(
        (acc, linha) => {
          acc.valorUnitarioTotal += linha.valorUnitario;
          acc.valorTotalItens += Number(linha?.valorTotal) || 0;
          acc.valorTotalDesconto += Number(linha?.desconto) || 0;
          return acc;
        },
        {
          valorUnitarioTotal: 0,
          valorTotalItens: 0,
          valorTotalDesconto: 0,
        }
      );

      this.form.valorTotalItens = valoresTotais.valorTotalItens;
      this.form.valorTotalDesconto = valoresTotais.valorTotalDesconto;
    },
    existeItemReprovado: function (linha) {
      return linha.orcamentoItemDetalhe.some(
        (item) => item.quantidadeAprovada != item.quantidade
      );
    },
    atualizaInstrumento (instrumentoAtualizado) {
      let nomeAtualizado = instrumentoAtualizado.codigoTag

      let orcamentoItem = this.form.orcamentoItem[this.indexAtualInstrumento];

      if (orcamentoItem) {
        orcamentoItem.instrumentosNomes[this.indexInstrumentoNome] = nomeAtualizado;

        orcamentoItem.orcamentoItemInstrumento[this.indexInstrumentoNome] = {
          ...orcamentoItem.orcamentoItemInstrumento[this.indexInstrumentoNome],
          nome: nomeAtualizado
        };

        this.indexOrcamentoItemId = "";
        this.indexInstrumentoNome = 0;

        this.keyAtualiza++;
        this.$forceUpdate();
      }

    }
  },
};
</script>
<style lang="scss">
.description-tr {
  line-height: 16px;
}

.th-simple-table {
  background-color: #d0d5dd;
}

.cursor-pointer {
  cursor: pointer;
}

.texto-descricao {
  max-width: 25ch !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}

.v-data-table {
  line-height: 0.5 !important;
}

.v-data-table__wrapper {
  overflow-x: auto;
  line-height: normal !important;
}

.v-simple-table {
  line-height: 0.5 !important;
}

.theme--light.v-data-table tbody tr:nth-of-type(even) {
  background-color: rgba(0, 0, 0, 0.03);
}

.theme--dark.v-data-table tbody tr:nth-of-type(even) {
  background-color: rgba(0, 0, 0, 0.5);
}

.descricao-obrigatorio {
  position: relative;

  .descricao-obrigatorio-asterisco {
    position: absolute;
    top: -4px;
    right: -4px;
  }
}

.subtable-itens-orcamento {
  margin: 0 0 16px 85px !important;
}
</style>
